import { Component, Input, SimpleChanges } from "@angular/core";
import { Login, PendenciaAssinatura, Rcms, RcmsStorage } from "eddydata-lib";
import { ConfirmationService } from "primeng/api";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RcmsStorageService } from '../service/rcms-storage.service';
import * as toastr from 'toastr';
import { PendenciaAssinaturaService } from "projects/eddydata-lib/src/lib/pendencia-assinatura/service/pendencia-assinatura.service";

declare var $: any;

@Component({
  selector: 'lib-rcms-historico-assinatura',
  templateUrl: './rcms-historico-assinatura.component.html'
})
export class RcmsHistoricoAssinaturaComponent {

  @Input() public login: Login;
  @Input() public entidade: Rcms;
  public pendenciaAssinatura: PendenciaAssinatura[] = [];

  protected unsubscribe: Subject<void> = new Subject();


  constructor(
    protected confirmationService: ConfirmationService,
    private pendenciaAssinaturaService: PendenciaAssinaturaService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entidade'] && this.entidade?.id) {
      this.pendenciaAssinaturaService
        .filtrar(1, -1, { id_entidade: this.entidade.id, 'etapa.etapa.nome': 'NOVA_REQUISICAO', relations: 'usuario_assinatura,etapa.perfil', orderBy: 'id$DESC' })
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          for (const item of res.content as PendenciaAssinatura[]) {
            if (item.motivo == null && item.status == 'RECUSADO') {
              item.status = 'PENDENTE'
            }
            if (item.motivo != null && item.status == 'PENDENTE') {
              item.status = 'RECUSADO'
            }
            if (item.motivo == null && item.status == 'PENDENTE' && item?.data_assinatura) {
              item.status = 'ASSINADO'
            }
            item.descricao = this.removerJustificativa(item.descricao)
            this.pendenciaAssinatura.push(item);
          }
        }, (res) => {
          toastr.error(res.error.payload);
        });
    }

  }

 public removerJustificativa(texto: string): string {
  const regex = /(.*?)(?:Justificativa:)[\s\S]*/i;
  const match = texto.match(regex);
  return match ? match[1].trim() : texto.trim();
}


}